<template>
  <Content id="scanTestTubeLog">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
         <Col>
           <FormItem label="发管">
             <Select v-model="search.tubeStatus" style="min-width: 95px;" :clearable="true">
               <Option v-for="item in tubeStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
             </Select>
           </FormItem>
         </Col>
          <Col>
            <FormItem label="拒检">
              <Select v-model="search.rejectStatus" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in rejectStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血">
              <Select v-model="search.checkStatus" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in checkStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="加项">
              <Select v-model="search.optionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in optionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="日期">
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd"
                          v-model="search.startDate" @on-change="changestart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd"
                          v-model="search.endDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="130"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="100"/>
      <el-table-column fixed align="center" prop="schoolName" label="学校" show-overflow-tooltip  min-width="200"/>
      <el-table-column align="center" prop="tubeStatus" label="发管" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.tubeStatus === 2 ? 'primary' : 'danger'" disable-transitions>{{  row.tubeStatus == 2 ? '已发管' : row.tubeStatus == 1 ? '未发管' : '未知'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="rejectStatus" label="拒检" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.rejectStatus === 1 ? 'primary' : 'danger'" disable-transitions>{{  row.rejectStatus == 2 ? '是' : row.rejectStatus == 1 ? '否' : '未知'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="checkStatus" label="抽血" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.checkStatus === 2 ? 'warning' : row.checkStatus === 3 ? 'primary' : 'danger'" disable-transitions>
            {{  checkStatusList.filter(u => u.value === row.checkStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="optionsStatus" label="加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.optionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.optionsStatus == 1 ? '无加项' : row.optionsStatus == 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="reason" label="原因" min-width="200"/>
      <el-table-column align="center" prop="remark" label="备注" min-width="200"/>
      <el-table-column align="center" prop="sources" label="来源" min-width="80">
        <template slot-scope="{row}">{{  row.sources == 1 ? 'pc端' : row.sources == 2 ? '小程序' : row.sources == 3 ? '定时器' : '' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="createTime" label="操作时间" min-width="180"/>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {_page} from "@/services/operationRecord/scanTestTubeLog.js";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "scanTestTubeLog",
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        barCode:"",
        taskId:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        name:"",
        checkStatus:"",
        optionsStatus:"",
        startDate:"",
        endDate:"",
        barCodes:"",
      },
      enums:enums,
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
      rejectStatusList:[
        {label: '全部', value: ''},
        {label: '否', value: 1},
        {label: '是', value: 2},
      ],
      checkStatusList:[
        {label: '全部', value: ''},
        {label: '未抽血', value: 1},
        {label: '部分抽血', value: 2},
        {label: '已抽血', value: 3},
      ],
      tubeStatusList:[
        {label: '全部', value: ''},
        {label: '未发管', value: 1},
        {label: '已发管', value: 2},
      ],
      optionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.applyTaskList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
